import axios from "axios";
import { API_ENDPOINT } from "../../common/constants/apiConstants";


export const addStudent = async(payload) => {
    const url = `${API_ENDPOINT.STUDENT_MANAGEMENT.CREATE}`;
    try {
      const response = await axios.post(url, payload);
      return response.data;
    } catch (error) {
      console.error("Add Student API Failed:", error);
      throw error.response?.data || { message: "Network error" };
    }
  };

export const getAllStudents = async (params = {}) => {
  const url = `${API_ENDPOINT.STUDENT_MANAGEMENT.GET_ALL}`;
  try {
    const response = await axios.get(url, { params, signal: params.signal });
    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return;
    console.error("Get All Students API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getActiveInterviews = async (email) => {
  const url = `${API_ENDPOINT.STUDENT_MANAGEMENT.ACTIVE_INTERVIEW}`;
  try {
    const response = await axios.post(url,  { email  });
    return response.data;
  } catch (error) {
    console.error("active interviews API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getStudentStats = async()=>{
  const url = `${API_ENDPOINT.STUDENT_MANAGEMENT.STUDENT_STATS}`;
  try{
    const response = await axios.get(url);
    return response.data;
  }catch(error){
    console.error("active interviews API Failed:", error);
    throw error.response?.data || { message: "Network error"};
  }
}

export const editStudent = async (studentId, payload) => {
  const url = `${API_ENDPOINT.STUDENT_MANAGEMENT.EDIT_STUDENT}${studentId}`;
  try {
    const response = await axios.put(url, payload);
    return response.data;
  } catch (error) {
    console.error("Edit Student API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const addBulkStudent = async(payload) =>{
  const url = `${API_ENDPOINT.STUDENT_MANAGEMENT.ADD_BULK_STUDENT}`;
  try{
    const response = await axios.post(url, payload);
    return response.data;
  }catch(error){
    console.error("Add bulk Student API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
}